import axios, { AxiosInstance } from 'axios';
import { ReactNode, createContext, useContext, useMemo } from 'react';

export type AxiosContextData = AxiosInstance;

export type AxiosProviderProps = {
  readonly children: ReactNode;
};

const AxiosContext = createContext<Partial<AxiosContextData>>({});

export const AxiosProvider = ({ children }: AxiosProviderProps) => {
  const value = useMemo<AxiosContextData>(() => axios.create({ withCredentials: true }), []);
  return <AxiosContext.Provider value={value}>{children}</AxiosContext.Provider>;
};

export const useAxios = () => useContext(AxiosContext) as AxiosContextData;
